var t = {};
export {
  t as __exports
};
//# sourceMappingURL=index.es333.js.map
